import { h } from 'preact';
import { Tab } from '@headlessui/react';
import clsx from 'clsx';
import { useDrawer } from '../drawer-context';
import AddToCartButton from './add-to-cart-button';
import RandomizeButton from '../threekit-components/randomize-button';
import ActionSheetButton from './action-sheet-button';
import HelpButton from './help-button';
import { useThreekit } from '../threekit-context';
import { useModal } from '../modal-context';

function DrawerButtonGroup() {
  const { drawerName, openDrawer, drawerCategories } = useDrawer();
  const { openModal } = useModal();
  const {
    darkMode,
    getBackgroundColorFromSelectedVariant,
    productTag,
    setKnifeClickActive,
  } = useThreekit();
  const tabIndex = drawerCategories.indexOf(drawerName); // Helps with animation changes

  const variantBackgroundColor = getBackgroundColorFromSelectedVariant();

  const handleTabClick = (tabName) => {
    setKnifeClickActive(false);
    openDrawer(tabName);
  };

  const handleClose = () => {
    if (productTag === 'cstm:service') {
      const laserMarkingInput = document.querySelector('#add_lasermarking');
      if (laserMarkingInput) {
        laserMarkingInput.checked = false;
      }
      const closeCustomizerEvent = new Event('closeCustomizer');
      document.dispatchEvent(closeCustomizerEvent);
      document.body.classList.remove('overflow-hidden');
      window.serviceProductInfo = null;
      return;
    }

    openModal('Exit');
  };

  return (
    <div className="absolute inset-0 grid grid-cols-[40px_minmax(0,_1fr)_40px] items-center p-[10px] laptop:p-[20px] max-h-[80px]">
      <div className="order-first">
        <button type="button" onClick={handleClose}>
          {darkMode ? (
            <img
              className="w-[36px] h-[28px]"
              src="https://cdn.shopify.com/s/files/1/0662/2134/2979/files/new-butterfly_1.png?v=1678203548"
              alt="Benchmade Customizer"
            />
          ) : (
            <img
              className="w-[36px] h-[28px]"
              src="https://cdn.shopify.com/s/files/1/0662/2134/2979/files/new-butterfly_1_7284c3a5-7313-4d43-bfe9-f8c447240fba.png?v=1679581333"
              alt="Benchmade Customizer"
            />
          )}
        </button>
      </div>
      {drawerCategories.length > 1 && (
        <div className="flex justify-center">
          <Tab.Group selectedIndex={tabIndex}>
            <Tab.List
              className={clsx(
                'flex p-1 rounded-sm bg-bg-1 h-[36px] laptop:h-[40px] space-evenly gap-2',
                {
                  'bg-opacity-20': darkMode,
                },
              )}
            >
              {drawerCategories.map((tabName) => {
                const isSelected = tabName === drawerName;

                return (
                  <Tab
                    className={clsx(
                      'uppercase rounded-sm font-m-10 laptop:font-m-12 px-[14px]',
                      {
                        'ui-not-selected:text-white ui-selected:bg-bg-1 ui-selected:text-white':
                          darkMode,
                        'ui-not-selected:text-black ui-selected:text-white':
                          !darkMode,
                      },
                      !darkMode && variantBackgroundColor?.isDark
                        ? 'ui-selected:text-white'
                        : 'ui-selected:text-black',
                    )}
                    onClick={() => handleTabClick(tabName)}
                    key={`tab-${tabName}`}
                    style={{
                      ...(!darkMode
                        && isSelected && {
                        backgroundColor: variantBackgroundColor?.hex,
                      }),
                    }}
                  >
                    {tabName}
                  </Tab>
                );
              })}
            </Tab.List>
          </Tab.Group>
        </div>
      )}
      <div className="flex justify-end order-last">
        <div className="laptop:hidden">
          <RandomizeButton />
        </div>
        <div className="justify-end hidden laptop:flex gap-2.5">
          <HelpButton />
          <ActionSheetButton />
          <AddToCartButton className="max-w-[181px]" />
        </div>
      </div>
    </div>
  );
}

export default DrawerButtonGroup;
